if(!document.documentElement.classList.contains('borders')) {
    document.addEventListener('DOMContentLoaded', function() {
      var contentWrapper = document.getElementById('content'),
          projectWrapper = document.getElementById('project'),
          next = document.getElementById('next'),
          prev = document.getElementById('prev'),
          index = document.getElementById('index'),
          projects = document.getElementsByClassName('project'),
          localLinks = document.getElementsByClassName('self'),
          currActive = document.getElementsByClassName('active'),
          allArticles = document.getElementsByTagName('article');

      var getNext = function() {
        var idx;
        if(currActive.length !== 0) {
          idx = Array.prototype.indexOf.call(allArticles, currActive[0]); 
          idx = idx === allArticles.length - 1 ? 0 : idx + 1; 
        } else {
          idx = 0;
        }
        return allArticles[idx];
      }

      var getPrev = function() {
        var idx;
        if(currActive.length !== 0) {
          idx = Array.prototype.indexOf.call(allArticles, currActive[0]); 
          idx = idx === 0 ? allArticles.length - 1 : idx - 1; 
        } else {
          idx = allArticles.length - 1;
        }
        return allArticles[idx];
      }

      var getArticle = function(proj) {
        var name = proj.dataset.url;
        return document.getElementById(name); 
      }

      var updateHeight = function() {
        if(currActive.length !== 0) {
          contentWrapper.style.height = currActive[0].getBoundingClientRect().height + 'px';
        }
      }

      var getBigImage = function(src, oldImg, request) {
        request.open('GET', src, true);
        request.onload = function() {
          if(request.status >= 200 && request.status < 400) {
            var newImg = new Image();
            newImg.src = src;
            newImg.onload = function() {
              oldImg.src = src;
              oldImg.classList.remove('tiny');
              updateHeight();
            }
          } else {
            console.log('Error:' + request.status);
          }
        }
        request.onerror = function() {
          console.log('Connection error');
        };
        request.send();
      }

      var initializeMedia = function(proj) {
        var vids = proj.querySelectorAll('video.autoplay'),
            imgs = proj.querySelectorAll('img');

        for(var i = 0; i<imgs.length; i++) {
          var oldImg = imgs[i],
              src = oldImg.src.replace('imgtiny/', '');
              request = new XMLHttpRequest();
          oldImg.onload = updateHeight;
          getBigImage(src, oldImg, request);
        }

        for(var i=0; i<vids.length; i++) {
          var img = new Image();
          img.src = vids[i].poster;
          img.onload = updateHeight;
          vids[i].play();
        }
      }

      var stopMedia = function(proj) {
        var vids = proj.querySelectorAll('video');
        for(var i=0; i<vids.length; i++) {
          vids[i].pause();
          vids[i].currentTime = 0;
        }
      }

      var goToTop = function(distance, cb) {
        if(document.body.scrollTop !== 0 || document.documentElement.scrollTop !== 0) {
          document.body.scrollTop -= distance/10;
          document.documentElement.scrollTop -= distance/10;
          setTimeout(function(){goToTop(distance, cb)}, 30);
        } else {
          if(!!cb) cb();
        }
      }

      var activateProject = function(el) {
        var projToDeactivate, oldHeight = document.body.scrollTop + document.documentElement.scrollTop;
        if(currActive.length !== 0) projToDeactivate = currActive[0];
        
        if(!!projToDeactivate) {
          oldHeight = projToDeactivate.getBoundingClientRect().height;
          projToDeactivate.classList.add('invisible');
          stopMedia(projToDeactivate);
        }

        goToTop(oldHeight, function(){
          initializeMedia(el);  
          el.classList.add('active');
          el.classList.remove('invisible');
          contentWrapper.style.height = el.getBoundingClientRect().height + 'px';
          if(!!projToDeactivate) {
            projToDeactivate.classList.remove('active');
          }
        });
        
      }

      var goToIndex = function () {
        if(currActive.length !== 0) {
          stopMedia(currActive[0]);
          currActive[0].classList.add('invisible');
          contentWrapper.style.height = '0px';
          currActive[0].classList.remove('active');
        }
      }

      var loadFromHash = function() {
        if(window.location.hash.length !== 0) {
          var el = document.getElementById(window.location.hash.substr(2));
          activateProject(el);
        } else {
          goToIndex();
        }
      }


      for(var i=0;i<projects.length;i++) {
        projects[i].addEventListener('click', function() {
          if(currActive.length !== 0 && currActive[0] == getArticle(this)) {
            goToTop(document.body.scrollTop + document.documentElement.scrollTop);
          } else {
            window.location.hash = '!'+ getArticle(this).id;
          }
        })
      }

      index.addEventListener('click', function() {
        window.location.hash = '';
      });

      next.addEventListener('click', function() {
        window.location.hash = '!'+ getNext().id;
      })

      prev.addEventListener('click', function() {
        window.location.hash = '!'+ getPrev().id;
      })

      window.onhashchange = loadFromHash;

      window.onresize = updateHeight;

      window.onkeyup = function(e) {
        switch(e.keyCode) {
          case 39: next.dispatchEvent(new MouseEvent('click')); break;
          case 37: prev.dispatchEvent(new MouseEvent('click')); break;
          case 27: index.dispatchEvent(new MouseEvent('click')); break;
          default: break;
        }
      }

      loadFromHash();

    });
    

}

